import React from "react";
import RequireAuth from "./RequireAuth";
import { usePermission } from "../context/PermissionContext";
import YetkisizErisim from "../pages/kuyumcu/components/YetkisizErisim";

/**
 * requiredPermission verilirse: yetki kontrol eder
 * requiredPermission verilmezse: sadece login kontrolü (RequireAuth)
 */
export default function ProtectedRoute({ requiredPermission, children }) {
  const { isLoading, can } = usePermission();

  // Permission gerekmeyen sayfalar (örn /kuyumcu): sadece auth kontrol
  if (!requiredPermission) {
    return <RequireAuth>{children}</RequireAuth>;
  }

  // Permission gereken sayfalarda yetkiler yüklenene kadar bekle
  if (isLoading) {
    return (
      <div style={{ padding: 24 }}>
        Yetkiler kontrol ediliyor...
      </div>
    );
  }

  // Yetki yoksa
  if (!can(requiredPermission)) {
    return <YetkisizErisim />;
  }

  // Yetki varsa
  return <RequireAuth>{children}</RequireAuth>;
}
